import { useQuery } from '@apollo/client';
import { PAYMENT_REQUEST_COMMENTS } from '@src/graphql/queries/paymentRequest';
import { useAuth } from '@src/hooks/useAuth';
export const useClaimsComments = ({ paymentRequestId }) => {
    const { currentUser } = useAuth();
    const { data, loading, refetch, error } = useQuery(PAYMENT_REQUEST_COMMENTS, {
        variables: {
            id: paymentRequestId,
        },
        skip: !currentUser || !paymentRequestId,
    });
    const comments = (data?.paymentRequestComments ?? []);
    return {
        comments,
        loading,
        refetch,
        error,
    };
};
